import React, { useEffect } from 'react';
import Modal from '../Modal';
import TrafficCard from './TrafficCard';

import { ReactComponent as CloseIcon } from '../images/x.svg';
import { ReactComponent as Spinner } from '../images/spinner.svg';

const TrafficModal = ({setVisible, user, saveUser}) => {
  let [traffic, setTraffic] = React.useState(null);

  useEffect(() => {

    fetch(process.env.REACT_APP_SERVER_URL + '/api/get-user-traffic', {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        websites: user.websites,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setTraffic(data.traffic);
        }
      })
      .catch(error => console.log(error));

  }, [user]);

  return (
    <Modal isOpen={true}
           zIndex={100} >
      <div style={{
             background: 'linear-gradient(gray, transparent)',
             zIndex: '101',
             position: 'absolute',
             transform: 'translate(-50%, -50%)',
             top: '50%',
             left: '50%',
             width: '1000px',
             borderRadius: '10px',
           }}>
        <div
          style={{
            margin: '1px',
            borderRadius: '10px',
            zIndex: '1002',
            display: 'flex',
            flexDirection: 'column',
            padding: '20px',
            backgroundColor: 'black',
            overflowY: 'auto',
            height: '600px',
            gap: '10px',
          }}>
          <div style={{
                 display: 'flex',
                 flexDirection: 'row',
                 alignItems: 'center',
                 justifyContent: 'space-between',
                 width: '100%',
               }}>
            <span style={{fontSize: '22px',
                          fontWeight: 'bold',
                         }}>
              Traffic for {user.name}
            </span>
            <CloseIcon className='image'
                       style={{width: '15px',
                               height: '15px',
                               fill: 'white',
                              }}
                       onClick={() => setVisible(false)} />
          </div>
          {traffic && (
            traffic.map((item, index) => (
              <TrafficCard key={index} data={item}/>
            ))
          )}
          {!traffic && (
            <div style={{height: '100%',
                         display: 'flex',
                         alignItems: 'center',
                         justifyContent: 'center',
                        }}>
              <Spinner style={{
                       margin: '0 auto',
                       width: '80px',
                       height: '80px',
                       animation: 'spin 1s linear infinite',
                     }} />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default TrafficModal;
